export default "__VITE_ASSET__BQC3aUB1__"